import { render, staticRenderFns } from "./QuestionShow.vue?vue&type=template&id=6654a787&scoped=true&"
import script from "./QuestionShow.vue?vue&type=script&lang=js&"
export * from "./QuestionShow.vue?vue&type=script&lang=js&"
import style0 from "./QuestionShow.vue?vue&type=style&index=0&id=6654a787&lang=scss&scoped=true&"
import style1 from "./QuestionShow.vue?vue&type=style&index=1&id=6654a787&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6654a787",
  null
  
)

export default component.exports